import { useState } from "react";
import { toast } from "sonner";
import { MapPin, Plus } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, useFetch, Spinner } from "@/components/portal/ui";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";

export default function Locations() {
  const { data, loading, setData } = useFetch(() => api.get("/portal/locations").then((r) => r.data));
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ label: "", address: "", city: "", contact: "" });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async () => {
    try {
      await api.post("/portal/locations", f);
      const r = await api.get("/portal/locations");
      setData(r.data); setOpen(false); setF({ label: "", address: "", city: "", contact: "" });
      toast.success("Location added");
    } catch { toast.error("Failed to add location"); }
  };

  if (loading) return <Spinner />;
  return (
    <div>
      <PageHeader title="Delivery Locations" subtitle="Manage your pickup and delivery addresses">
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button className="bg-primary hover:bg-red-700" data-testid="add-location-btn"><Plus size={16} className="mr-2" /> Add Location</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Add delivery location</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Label</Label><Input data-testid="loc-label" value={f.label} onChange={set("label")} placeholder="e.g. Century City DC" className="mt-1.5" /></div>
              <div><Label>Address</Label><Input data-testid="loc-address" value={f.address} onChange={set("address")} className="mt-1.5" /></div>
              <div><Label>City</Label><Input data-testid="loc-city" value={f.city} onChange={set("city")} className="mt-1.5" /></div>
              <div><Label>Contact</Label><Input data-testid="loc-contact" value={f.contact} onChange={set("contact")} className="mt-1.5" /></div>
            </div>
            <DialogFooter><Button className="bg-primary hover:bg-red-700" onClick={submit} data-testid="loc-submit">Save</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </PageHeader>
      {data.locations.length === 0 ? (
        <div className="rounded-xl border border-dashed border-border p-12 text-center text-muted-foreground">No saved locations. Add your first delivery address.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {data.locations.map((l) => (
            <div key={l.id} className="rounded-xl border border-border bg-card p-5" data-testid={`location-${l.id}`}>
              <MapPin className="text-primary" size={22} />
              <h3 className="mt-3 font-heading font-bold">{l.label}</h3>
              <p className="text-sm text-muted-foreground mt-1">{l.address}</p>
              <p className="text-sm mt-1">{l.city}</p>
              {l.contact && <p className="text-xs text-muted-foreground mt-2">Contact: {l.contact}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
